var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Kam',{staticClass:"pb-60 md:pb-0"})}
var staticRenderFns = []

export { render, staticRenderFns }